import HeaderPremium from "./HeaderPremium";
import { useAuth } from "../context/AuthContext";

export default function AdminHeader() {

  const { logout } = useAuth();

  return (
    <HeaderPremium
      variant="admin"
      onLogout={logout}
    />
  );
}